/* eslint-disable no-console */
import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Auth } from '@aws-amplify/auth';
import { CognitoIdToken, CognitoUserSession } from 'amazon-cognito-identity-js';

import { AuthContext } from './auth-context';
import { appConfig } from '../../config/app-config';

export const InContainerAuthProvider = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => {
  const [userTokenData, setUserTokenData] = useState<
    Record<string, any> | undefined
  >(undefined);
  const [triedToFetchTheUser, setTriedToFetchTheUser] =
    useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const getUserData = useCallback(async (): Promise<
    Record<string, any> | undefined
  > => {
    try {
      console.log('getUserData try');
      console.log(Auth);
      const currentSession: CognitoUserSession = await Auth.currentSession();
      console.log('Current session in store', currentSession);
      const userData: CognitoIdToken = currentSession.getIdToken();
      console.log('Current userData', userData);

      return userData.payload;
    } catch (ex: any) {
      console.log('Im in catch', ex);
      return undefined;
    } finally {
      console.log('Im in finally');
      setTriedToFetchTheUser(true);
    }
  }, []);

  const onLoad = useCallback(async () => {
    try {
      Auth.configure(appConfig.auth);

      setUserTokenData(await getUserData());
    } catch (error) {
      setError(error);
    }
  }, [getUserData]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <AuthContext.Provider value={{ userTokenData, triedToFetchTheUser, error }}>
      {children}
    </AuthContext.Provider>
  );
};
